import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.managementService


//根据条件查询菜单列表
export function getTRoleSelectByPage(data) {
    return request({
        url: serviceName + `/role/list`,
        method: 'post',
        data:data
    })
}


//新增数据
export function postTRoleInsertAdd(data) {
    return request({
        url: serviceName + `/role/add`,
        method: 'post',
        data: data
    })
}


//修改数据
export function postTRoleUpdate(data) {
    return request({
        url: serviceName + `/role/update`,
        method: 'post',
        data: data
    })
}


//删除数据
export function postTRoleDelete(data) {
    return request({
        url: serviceName + `/tRole/delete`,
        method: 'post',
        data: data
    })
}
//通过主键查询单条数据
export function getTRoleIDdep(id) {
    return request({
        url: serviceName + `/tRole/${id}`,
        method: 'get',
    })
}

//修改状态
export function postTRoleUpdateStatus(data) {
    return request({
        url: serviceName + `/role/isValid`,
        method: 'post',
        data: data
    })
}